import { api } from '../services/api.js';

/**
 * 390 (#1310) — saves a finished rental's receipt PDF, the same file the customer downloads. The name repeats the
 * platform's receipt number rule (`R` + the last 8 characters of the rental's id, upper case;
 * `backend/src/modules/receipts/receipt.ts`), because a saved object URL cannot carry the server's file name.
 */
export async function downloadReceipt(bookingId: string, rentalId: string): Promise<void> {
  const url = await api.getBlobUrl(`/bookings/${bookingId}/receipt`);
  const link = document.createElement('a');
  link.href = url;
  link.download = `CARii-receipt-R${rentalId.slice(-8).toUpperCase()}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
